module.exports = __webpack_public_path__ + "static/media/OpenSans-Italic.f6238deb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/OpenSans/OpenSans-Italic.ttf
// module id = 307
// module chunks = 0